import { type AddHookResponse, mutationAdd } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useDispositionCache } from './cache'
import {
  toResponseError,
  type DispositionData,
  type UnsavedDisposition,
  type DispositionAddInput,
  type DispositionAddSuccess,
} from '@terros/common'

export function useAddDisposition(): AddHookResponse<UnsavedDisposition, DispositionData> {
  const mutation = useTantalimMutation<DispositionAddInput, DispositionAddSuccess>({ url: '/disposition/add' })
  const cache = useDispositionCache()
  async function add(unsaved: UnsavedDisposition): Promise<DispositionData> {
    try {
      const { disposition: saved } = await mutation.mutateAsync({ disposition: unsaved })
      cache.addItem(saved)
      cache.appendItem(saved)
      return saved
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
